import { useTranslation } from 'react-i18next'
import { ActivityIndicator, TextArea } from '@bosch/react-frok'

import useAudioRecording from '@/hooks/useAudioRecording'
import InputAudio from '@/ui/components/InputAudio/InputAudio'
import useSetQuestion from '@/ui/components/InputAudio/useSetQuestion'
import MicrophoneButton from '@/ui/components/InputAudio/MicrophoneButton'
import { Settings } from '@/utils/constants'
import type { FeedbackInputAreaProps } from './types/FeedBackInputAreaTypes'

import './FeedBackInputArea.scss'

const FeedbackInputArea = ({
    text,
    updateText,
    waitingForResponse,
    disabled,
    isLoading,
    assistant,
}: FeedbackInputAreaProps) => {
    const { t } = useTranslation()
    const { audioInputProps, isRecording, isTranscribing, toggleRecording } = useAudioRecording()
    const setQuestion = useSetQuestion(text, updateText)

    return (
        <div className="feedback-input-container">
            <div className="feedback-input-text-area-container">
                <TextArea
                    id="text"
                    className="feedback-input-text-area"
                    label={t('generalFeedback:label')}
                    title={t('generalFeedback:tooltip')}
                    maxLength={Settings.feedbackMaxLength}
                    value={text}
                    disabled={disabled}
                    dynamicHeight
                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => updateText(event.target.value)}
                />
                {(isLoading || isTranscribing) && (
                    <div className="feedback-input-loading-overlay">
                        <ActivityIndicator size="small" />
                    </div>
                )}
            </div>
            <div className="audio-button-container">
                <InputAudio
                    {...audioInputProps}
                    setQuestion={setQuestion}
                    assistant={assistant}
                    validateTokenAndRehydrate={undefined}
                    background="transparent"
                />
                <MicrophoneButton
                    isRecording={isRecording}
                    onClick={toggleRecording}
                    disabled={waitingForResponse || isTranscribing}
                />
            </div>
        </div>
    )
}

export default FeedbackInputArea
